import React, { ComponentProps, FC } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

type PaginationButtonProps = StylableComponent<HTMLDivElement> &
  ComponentProps<typeof Button>;

const PaginationButton: FC<PaginationButtonProps> = ({
  onClick,
  disabled,
  renderIcon,
  style,
  ...props
}) => {
  const theme = useTheme();
  const buttonTokens = theme.tokens?.component?.table?.pagination?.button;

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={Button.VARIANTS.TERTIARY}
      size={Button.SIZES.SMALL}
      style={[
        {
          color: disabled
            ? buttonTokens?.disabled?.color
            : buttonTokens?._?.color,
          padding: 0,
          lineHeight: 1,
        },
        style,
      ]}
      {...props}
    >
      {renderIcon?.({ size: 20 })}
    </Button>
  );
};

PaginationButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  renderIcon: PropTypes.func.isRequired,
  style: stylePropType,
};

export default PaginationButton;
